import React from 'react';

import Icon from 'components/Icon';

import { IPropTypes as IconProps } from 'e100-react-components/lib/components/Icon'

import classNames from 'classnames';

import { useStyles } from './styles';

export const DateTimePickerArrowIcon = ({
  classes = {},
  color = 'secondary'
}: DateTimePickerArrowIconProps) => {
  const innerClasses = useStyles();
  return (
    <Icon
      kind={'arrowDropDown'}
      color={color}
      classes={{
        root: classNames(innerClasses.root, classes.root)
      }}
    />
  );
};

interface DateTimePickerArrowIconClasses {
  root?: string;
}
interface DateTimePickerArrowIconProps {
  classes?: DateTimePickerArrowIconClasses;
  color?: IconProps['color'];
}